import { render, staticRenderFns } from "./orgSelect.vue?vue&type=template&id=7438557c&scoped=true"
import script from "./orgSelect.vue?vue&type=script&lang=js"
export * from "./orgSelect.vue?vue&type=script&lang=js"
import style0 from "./orgSelect.vue?vue&type=style&index=0&id=7438557c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7438557c",
  null
  
)

export default component.exports